/* This file implements all required API calls and preprocessing of API data*/
import axios from "axios";

// Generic function to retrieve data from an endpoint in the API
export const getApiData = async (path, defaultVal) => {
  try {
    let response = await axios.get(process.env.REACT_APP_POOL_API + path, {
      headers: {
        Authorization: "Token " + process.env.REACT_APP_POOL_API_AUTH,
      },
    });
    if (response && response.data) {
      return response.data;
    } else {
      return defaultVal;
    }
  } catch (e) {
    console.log(e);
    return defaultVal;
  }
};

// Retrieves specific ENS info for an Eth address
export async function getENSInfo(address) {
  try {
    let response = await axios.get(
      "https://stronk.rocks/api/livepeer/getENS/" + address
    );
    if (response && response.data) {
      return response.data;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
}

// Retrieves ENS cache
export async function getAllENS() {
  try {
    let response = await axios.get(
      "https://stronk.rocks/api/livepeer/getEnsDomains"
    );
    if (response && response.data) {
      return response.data;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
}
